import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Menu from "../components/Menu.js";
import Loading from "../components/Loading.js";
import "./Office.css";

const Office = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getFirestore();
  const [loading, setLoading] = useState(true);
  const [isUserRole, setIsUserRole] = useState(false);

  useEffect(() => {
    const checkUserRole = async () => {
      const user = auth.currentUser;

      if (!user) {
        alert("Por favor, inicia sesión para continuar.");
        navigate("/login");
        return;
      }

      try {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists() && userSnap.data().role) {
          const role = userSnap.data().role;

          if (role === "user") {
            setIsUserRole(true);
            setLoading(false);
          } else {
            // Redirigir automáticamente según el rol del usuario
            switch (role) {
              case "empresa":
                navigate("/empresa-office");
                break;
              case "postulante":
                navigate("/postulante-office");
                break;
              case "servicios":
                navigate("/servicios-office");
                break;
              case "presupuestos":
                navigate("/presupuestos-office");
                break;
              default:
                alert("Rol no reconocido. Contacta al administrador.");
                navigate("/");
                break;
            }
          }
        } else {
          alert("No se encontró información de rol. Contacta al administrador.");
          navigate("/");
        }
      } catch (error) {
        console.error("Error al verificar el rol del usuario: ", error);
        alert("Hubo un problema al verificar tu cuenta. Intenta de nuevo.");
        setLoading(false);
      }
    };

    checkUserRole();
  }, [auth, db, navigate]);

  const handleOptionSelect = async (role) => {
    const user = auth.currentUser;

    if (!user) {
      alert("Por favor, inicia sesión para continuar.");
      navigate("/login");
      return;
    }

    try {
      // Actualizar el rol del usuario en Firestore
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, { role });

      // Redirigir según la opción seleccionada
      switch (role) {
        case "empresa":
          navigate("/empresa-office");
          break;
        case "postulante":
          navigate("/postulante-office");
          break;
        case "servicios":
          navigate("/servicios-office");
          break;
        case "presupuestos":
          navigate("/presupuestos-office");
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error al actualizar el rol del usuario: ", error);
      alert("Hubo un problema al seleccionar la opción. Intenta de nuevo.");
    }
  };

  // Mostrar un mensaje de carga mientras se verifica el rol
  if (loading) {
    return <div><Loading /></div>;
  }

  // Si no es un rol válido, no mostrar nada (opcional)
  if (!isUserRole) {
    return null;
  }

  return (
    <div className="vp-container">
      <div className="vp-main-content">
        <div className="office-container">
          <h2>¡Bienvenido a la Oficina de Apimys!</h2>
          <p>Selecciona una opción para continuar:</p>
          <div className="office-options">
            <button
              className="office-button"
              onClick={() => handleOptionSelect("empresa")}
            >
              Oficina para contratar personal
            </button>
            <button
              className="office-button"
              onClick={() => handleOptionSelect("postulante")}
            >
              Oficina para postularse y recibir solicitudes de empleo
            </button>
            <button
              className="office-button"
              onClick={() => handleOptionSelect("servicios")}
            >
              Oficina para ofrecer servicios
            </button>
            <button
              className="office-button"
              onClick={() => handleOptionSelect("presupuestos")}
            >
              Solicitar presupuestos para una tarea
            </button>
          </div>
        </div>
      </div>
      <Menu />
    </div>
  );
};

export default Office;
